export default {"src":"/_next/static/media/features-background-left.4395feca.svg","height":1946,"width":831,"blurWidth":0,"blurHeight":0};